export default __webpack_public_path__ + "static/media/TowerImg.479e9726.svg";